/* eslint-disable no-unused-vars */

import React, { useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import CreateForm from './createForm';
import { IoIosCloseCircle } from 'react-icons/io';
import './style.css'
// import { sampleData } from './data';

const SlideForm = ({
  show,
  handleCloseModal,
  heading,
  slides,
  dataList,
  editForm,
  editData,
  setReloadData,
  subHeading
}) => {
  const [validationError, setValidationError] = useState('');
  const handleValidation = (selectedItems) => {
    if (selectedItems.length === 0) {
      setValidationError(`Please select at least one ${slides ? 'equipment' : 'slide'}`);
      return false;
    }
    setValidationError('');
    return true;
  };

  return (
    <Modal show={show} onHide={handleCloseModal} className="shopfloorForm">
      <Modal.Header className="flex-column align-items-center text-center ">
        <Modal.Title className='mt-4'> {heading}</Modal.Title>
        <p className="text-muted small mb-0 mt-1">
          {subHeading}
        </p>
        <div className="cross-close" onClick={handleCloseModal}>
          <IoIosCloseCircle />
        </div>
      </Modal.Header>

      <Modal.Body>
        {validationError && (
          <Alert variant="danger" onClose={() => setValidationError('')} dismissible>
            {validationError}
          </Alert>
        )}

        <CreateForm
          itemList={dataList}
          handleCloseModal={handleCloseModal}
          slides={slides}
          editForm={editForm}
          editData={editData}
          handleSubmit={(e) => {}}
          setReloadData={setReloadData}
        />
      </Modal.Body>
    </Modal>
  );
};

export default SlideForm;
